import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

import HomePage from './pages/homePage';
import ContactPage from './pages/contactPage';
import LunaPage from './pages/projects/LunaPage';
import DiceBotPage from './pages/projects/DiceBotPage';
import RailCartPage from './pages/projects/RailCartPage';

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<HomePage/>} />
          <Route path="/contact" element={<ContactPage/>} />
          <Route path="/projects/luna" element={<LunaPage/>} />
          <Route path="/projects/dice-bot" element={<DiceBotPage/>} />
          <Route path="/projects/rail-cart" element={<RailCartPage/>} />
        </Routes>
    </Router>
  );
}

export default App;
